define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/_base/underscore",
	"csi/locale",
	"csi/reflection",
	"csi/store/Names",
	"csi/store/_base",
	"csi/widget/ErrorText",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, Action, ViewRef, Widget, _, locale, reflection, Names, csiStore, ErrorText, xml, Query) {

	var _getAttributeGroupsStore = function() {
		// summary: return store of AttributeGroup names on Colorway and ColorwayAttributes
		var data = [];
		_getAttributeGroupNames(data, "Colorway");
		_getAttributeGroupNames(data, "ColorwayAttributes");

		return new Names({
			bSort: false, // not sure what sort order is?
			data: data
		});
	};

	var _getAttributeGroupNames = function(/*Array*/data, /*String*/type) {
		// Get name / display-name pairs for field store for attribute groups based on selected type
		_.each(reflection.getClass(type).attributeGroups, function(group) {
			var id = type + "/" + group.name;
			var name = group.name + " (" + locale.type(type) + ")";

			data.push(csiStore.nameObject(name, id));
		});
	};

	const _MessageText = declare(ErrorText, {
		infoResource: "PushColorwaysToStyles_AttributeGroupInfo"
	});

	return declare(Widget, {

		_getStoreOptions: function(/*Field*/ field) {
			return csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship);
		},

		/**
		 * @override
		 * Add the info message for atrribute groups field
		 */
		_resolveView: function() {
			this.defView.getField("AttributeGroups").messageClass = _MessageText;

			this.inherited(arguments);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			// summary: if field is AttributeGroups, then return store of AttributeGroup names on Colorway and ColorwayAttributes
			if (field.getControlName() == "AttributeGroups")
				return _getAttributeGroupsStore();
			else if (field.getControlName() == "Colorways") {
				var storeOptions = this._getStoreOptions(field);
				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "SelectProductColors",
						m_url: this.getViewNode()
					}),
					m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, true)
				});
				return new Names(storeOptions);
			}

			return this.inherited(arguments);
		}
	});
});


